import React from 'react';

import {
  AddCircle,
  ArrowBack,
  ArrowBackIos,
  ArrowForward,
  ArrowForwardIos,
  Close,
  Check,
  CheckCircle,
  CheckCircleOutline,
  ChevronLeft,
  ChevronRight,
  Clear,
  ExpandMore,
  RadioButtonUnchecked,
  FiberManualRecord,
  Search,
  Star,
  VerifiedUserOutlined,
  Delete,
  CreditCard,
  Info,
  ArrowDropDownCircle,
  Add,
  Done,
  ErrorOutline,
  ArrowDropDown,
  CloudDownload,
  Download,
  Image,
  PauseCircleOutlined,
} from '@mui/icons-material';

export const Icons = {
  addCircle: AddCircle,
  arrowBack: ArrowBack,
  arrowForward: ArrowForward,
  arrowBackIos: ArrowBackIos,
  arrowForwardIos: ArrowForwardIos,
  check: Check,
  checkCircle: CheckCircle,
  checkCircleOutline: CheckCircleOutline,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  expandMore: ExpandMore,
  radioButtonUnchecked: RadioButtonUnchecked,
  fiberManualRecord: FiberManualRecord,
  search: Search,
  star: Star,
  verifiedUserOutlined: VerifiedUserOutlined,
  x: Clear,
  delete: Delete,
  creditCard: CreditCard,
  info: Info,
  arrowDropDownCircle: ArrowDropDownCircle,
  add: Add,
  PauseCircleOutlined: PauseCircleOutlined,
  thumbUpOutlined: ({ ...props }) => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.68983 21.2441C5.96076 21.2441 4.55908 19.8425 4.55908 18.1134V9.45656C4.55908 8.74179 4.80366 8.04854 5.25218 7.49201L9.42815 2.31041C10.4386 1.05667 12.2839 0.882828 13.5107 1.92581C14.4423 2.71787 14.7679 4.0143 14.321 5.15254L13.2572 7.86197H18.6319C20.8952 7.86197 22.4106 10.1895 21.4951 12.2593L18.3451 19.3799C17.8438 20.5132 16.7212 21.2441 15.482 21.2441H7.68983ZM12.9114 4.59908C13.1218 4.06307 12.9685 3.45256 12.5298 3.07957C11.9521 2.58842 11.0831 2.67028 10.6073 3.26068L6.4313 8.44229C6.19973 8.72962 6.07346 9.08754 6.07346 9.45656V18.1134C6.07346 19.0061 6.79713 19.7298 7.68983 19.7298H15.482C16.1218 19.7298 16.7014 19.3524 16.9602 18.7673L20.1101 11.6466C20.5828 10.578 19.8004 9.37635 18.6319 9.37635H12.1464C11.896 9.37635 11.6618 9.25256 11.5208 9.04566C11.3797 8.83876 11.3501 8.57551 11.4416 8.34243L12.9114 4.59908Z"
      />
      <path d="M3.51438 19.2753C3.51438 19.6935 3.17537 20.0325 2.75719 20.0325C2.339 20.0325 2 19.6935 2 19.2753V9.58336C2 9.16518 2.33901 8.82617 2.75719 8.82617C3.17537 8.82617 3.51438 9.16518 3.51438 9.58336V19.2753Z" />
    </svg>
  ),
  uploadAlt: ({ ...props }) => (
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      stroke="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.5833 8.75V11.0833C12.5833 11.3928 12.4604 11.6895 12.2416 11.9083C12.0228 12.1271 11.7261 12.25 11.4166 12.25H3.24998C2.94056 12.25 2.64381 12.1271 2.42502 11.9083C2.20623 11.6895 2.08331 11.3928 2.08331 11.0833V8.75"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.25 4.66667L7.33329 1.75L4.41663 4.66667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M7.33331 1.75V8.75" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  bot: ({ ...props }) => (
    <svg
      width="24"
      height="20"
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 9.6V14.4C0 15.0638 0.53625 15.6 1.2 15.6H2.4V8.4H1.2C0.53625 8.4 0 8.93625 0 9.6ZM17.4 3.6H13.2V1.2C13.2 0.53625 12.6638 0 12 0C11.3363 0 10.8 0.53625 10.8 1.2V3.6H6.6C4.9425 3.6 3.6 4.9425 3.6 6.6V16.8C3.6 18.1238 4.67625 19.2 6 19.2H18C19.3238 19.2 20.4 18.1238 20.4 16.8V6.6C20.4 4.9425 19.0575 3.6 17.4 3.6ZM9.6 15.6H7.2V14.4H9.6V15.6ZM8.4 11.1C7.57125 11.1 6.9 10.4288 6.9 9.6C6.9 8.77125 7.57125 8.1 8.4 8.1C9.22875 8.1 9.9 8.77125 9.9 9.6C9.9 10.4288 9.22875 11.1 8.4 11.1ZM13.2 15.6H10.8V14.4H13.2V15.6ZM16.8 15.6H14.4V14.4H16.8V15.6ZM15.6 11.1C14.7713 11.1 14.1 10.4288 14.1 9.6C14.1 8.77125 14.7713 8.1 15.6 8.1C16.4288 8.1 17.1 8.77125 17.1 9.6C17.1 10.4288 16.4288 11.1 15.6 11.1ZM22.8 8.4H21.6V15.6H22.8C23.4638 15.6 24 15.0638 24 14.4V9.6C24 8.93625 23.4638 8.4 22.8 8.4Z"
        fill="currentColor"
      />
    </svg>
  ),
  offer: ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" {...props}>
      <path
        d="M12.093.097c-.776 0-1.328.397-1.797.714s-.9.586-1.083.638-.687.023-1.25-.017-1.243-.102-1.915.286-.953 1-1.2 1.52-.47.95-.613 1.092-.6.365-1.1.613-1.124.53-1.512 1.2-.317 1.35-.277 1.915.06 1.058.008 1.25-.322.614-.638 1.083S0 11.415 0 12.2s.397 1.328.714 1.797.586.9.638 1.083.03.687-.008 1.25-.1 1.243.277 1.915 1.003.953 1.512 1.2.958.47 1.1.613.365.583.613 1.092.53 1.132 1.2 1.52 1.35.317 1.915.277 1.058-.06 1.25-.008.614.322 1.083.638 1.022.714 1.797.714 1.328-.397 1.797-.714.9-.586 1.083-.638.687-.03 1.25.008 1.243.1 1.915-.277.953-1 1.2-1.52.47-.95.613-1.092.6-.365 1.1-.613 1.124-.53 1.512-1.2.325-1.35.286-1.915-.07-1.058-.017-1.25.322-.614.638-1.083.714-1.022.714-1.797-.397-1.328-.714-1.797-.586-.9-.638-1.083-.023-.687.017-1.25.102-1.243-.286-1.915-1.003-.953-1.512-1.2-.958-.47-1.1-.613-.365-.583-.613-1.092-.53-1.132-1.2-1.52-1.35-.325-1.915-.286-1.058.07-1.25.017-.61-.333-1.07-.65-1.03-.713-1.807-.713h0zm0 1.612c.118 0 .464.15.9.437s.9.686 1.57.865 1.268.07 1.78.034.897.008 1 .067.33.37.554.83.433 1.038.924 1.528 1.066.7 1.528.924.772.452.83.554.103.486.067 1-.137 1.1.042 1.78.57 1.144.857 1.57.437.772.437.9-.15.472-.437.9-.677.892-.857 1.562-.078 1.276-.042 1.8-.008.888-.067 1-.37.33-.83.554-1.038.442-1.528.932-.7 1.066-.924 1.528-.452.764-.554.823-.486.103-1 .067-1.1-.137-1.78.042-1.144.57-1.57.857-.772.437-.9.437-.472-.15-.9-.437-.892-.677-1.562-.857-1.276-.078-1.8-.042-.888-.008-1-.067-.33-.36-.554-.823-.442-1.038-.932-1.528-1.066-.707-1.528-.932-.764-.452-.823-.554-.103-.478-.067-1 .137-1.12-.042-1.8-.57-1.136-.857-1.562-.437-.78-.437-.9.15-.464.437-.9.677-.9.857-1.57.078-1.267.042-1.78.008-.897.067-1 .36-.33.823-.554 1.038-.433 1.528-.924.707-1.066.932-1.528.452-.772.554-.83.478-.103 1-.067 1.12.146 1.8-.034 1.136-.577 1.562-.865.78-.437.9-.437h0zm-3.225 4.3a2.97 2.97 0 0 0-2.956 2.956 2.97 2.97 0 0 0 2.956 2.956 2.97 2.97 0 0 0 2.956-2.956 2.97 2.97 0 0 0-2.956-2.956zM16.3 7.076c-.183.024-.352.1-.48.244l-8.6 8.6a.81.81 0 0 0 .345 1.388.8.8 0 0 0 .797-.254l8.6-8.6c.248-.242.314-.615.164-.927s-.483-.493-.827-.45h0zm-7.432.546a1.33 1.33 0 0 1 1.344 1.344 1.33 1.33 0 0 1-1.344 1.344 1.33 1.33 0 0 1-1.344-1.344 1.33 1.33 0 0 1 1.344-1.344zm6.45 4.837a2.97 2.97 0 0 0-2.956 2.956 2.97 2.97 0 0 0 2.956 2.956 2.97 2.97 0 0 0 2.956-2.956 2.97 2.97 0 0 0-2.956-2.956h0zm0 1.612a1.33 1.33 0 0 1 1.344 1.344 1.33 1.33 0 0 1-1.344 1.344 1.33 1.33 0 0 1-1.344-1.344 1.33 1.33 0 0 1 1.344-1.344h0z"
        fill="currentColor"
      />
    </svg>
  ),
  done: Done,
  errorOutline: ErrorOutline,
  arrowDropDownIcon: ArrowDropDown,
  cloudDownload: CloudDownload,
  errorOutline: ErrorOutline,
  download: Download,
  close: Close,
  image: Image,
  googleColored: (props) => {
    const { width = 26, height = 26, ...rest } = props || {};
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="-3 0 262 262"
        preserveAspectRatio="xMidYMid"
        {...props}
      >
        <path
          d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
          fill="#4285F4"
        />
        <path
          d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
          fill="#34A853"
        />
        <path
          d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
          fill="#FBBC05"
        />
        <path
          d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
          fill="#EB4335"
        />
      </svg>
    );
  },
  shieldCheck: (props) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <g clipPath="url(#clip0_789_74)">
          <path
            d="M12.387 1.42683L8.21034 0.0341605C8.07359 -0.0113868 7.92576 -0.0113868 7.78901 0.0341605L3.61234 1.42683C2.94828 1.64741 2.37062 2.07167 1.96144 2.6393C1.55226 3.20694 1.33237 3.88909 1.33301 4.58883V8.00016C1.33301 13.0422 7.46634 15.8268 7.72901 15.9428C7.81422 15.9807 7.90643 16.0002 7.99968 16.0002C8.09292 16.0002 8.18513 15.9807 8.27034 15.9428C8.53301 15.8268 14.6663 13.0422 14.6663 8.00016V4.58883C14.667 3.88909 14.4471 3.20694 14.0379 2.6393C13.6287 2.07167 13.0511 1.64741 12.387 1.42683ZM13.333 8.00016C13.333 11.6368 9.12034 14.0222 7.99968 14.5928C6.87768 14.0242 2.66634 11.6462 2.66634 8.00016V4.58883C2.66638 4.16901 2.79853 3.75985 3.04405 3.41932C3.28958 3.07879 3.63604 2.82416 4.03434 2.69149L7.99968 1.36949L11.965 2.69149C12.3633 2.82416 12.7098 3.07879 12.9553 3.41932C13.2008 3.75985 13.333 4.16901 13.333 4.58883V8.00016Z"
            fill="#5D6A81"
          />
          <path
            d="M10.1995 5.53338L7.40754 8.33338L5.91154 6.77338C5.8515 6.70774 5.77893 6.65478 5.69811 6.61761C5.61729 6.58045 5.52985 6.55984 5.44093 6.55699C5.35202 6.55414 5.26344 6.56912 5.18041 6.60104C5.09737 6.63295 5.02156 6.68116 4.95745 6.74283C4.89334 6.8045 4.84221 6.87837 4.80709 6.9601C4.77197 7.04183 4.75356 7.12976 4.75295 7.21872C4.75233 7.30767 4.76953 7.39585 4.80352 7.47806C4.83751 7.56027 4.88761 7.63484 4.95087 7.69738L6.4882 9.29738C6.60285 9.42122 6.74143 9.52051 6.89555 9.58927C7.04967 9.65802 7.21613 9.6948 7.38487 9.69738H7.40687C7.57224 9.69793 7.73607 9.66562 7.88885 9.60233C8.04164 9.53905 8.18033 9.44604 8.29687 9.32872L11.1449 6.48072C11.2071 6.41864 11.2564 6.34493 11.2902 6.26378C11.3239 6.18263 11.3413 6.09563 11.3414 6.00776C11.3415 5.91988 11.3242 5.83285 11.2907 5.75163C11.2572 5.67041 11.2079 5.59659 11.1459 5.53438C11.0838 5.47218 11.0101 5.42281 10.9289 5.3891C10.8478 5.35538 10.7608 5.33798 10.6729 5.33789C10.585 5.3378 10.498 5.35501 10.4168 5.38856C10.3356 5.4221 10.2617 5.47131 10.1995 5.53338Z"
            fill="#5D6A81"
          />
        </g>
        <defs>
          <clipPath id="clip0_789_74">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  },
};
